import { BaseBritishColumbiaObstetricalFileSubSection, BaseBritishColumbiaObstetricalFileSubSectionProps } from "@/Patient/Components/MedicalNote/Obstetric/Form/BritishColumbia/Subcomponent/BaseBritishColumbiaObstetricalFileSubSection";
import { BritishColumbiaObstetricalFileForm } from "@/Patient/Models/ObstetricalFile/BritishColumbia/BritishColumbiaObstetricalFileForm";

class BritishColumbiaObstetricalFileMedicalHistoryMentalHealth extends BaseBritishColumbiaObstetricalFileSubSection<BaseBritishColumbiaObstetricalFileSubSectionProps, never> {
    private sectionId = "MedicalHistory_Section7_";
    private medicalHistoryMentalHealthOther = `${this.sectionId}_Other`;

    public render(): JSX.Element {
        const section7 = this.props.form.Section7;

        return (
            <div className="col-md-12 flex-display section7-subfield padding-xs-top">
                <div className="flex-display">
                    {this.controlRenderer.renderInlineRadio({
                        value: section7.MentalHealth.HasMentalHealth,
                        items: this.getFalseTrueRadioOptionsWithoutLabel(),
                        onChange: value => this.props.mutateModelStateWithFormUpdate(s => s.Section7.MentalHealth.HasMentalHealth = value),
                        id: `${this.sectionId}_HasMentalHealth`,
                        className: "radios-one-label",
                        optionSpacing: "15px",
                        additionalWrapperClassName: "nowrap"
                    })}
                    <label className="margin-none margin-xs-left">{this.getString("ObstetricalFile_MentalHealthLabel")}</label>
                </div>
                <div style={{ flexGrow: 1 }}>
                    {this.controlRenderer.renderCheckbox(
                        "AnxietyLabel",
                        section7.MentalHealth.HasAnxiety,
                        value => this.mutateMentalHealthModel(s => s.Section7.MentalHealth.HasAnxiety = value, true),
                        "margin-md-left"
                    )}
                    <div className="inline-flex-center">
                        {this.controlRenderer.renderCheckbox(
                            "DepressionLabel",
                            section7.MentalHealth.HasDepression,
                            value => this.mutateMentalHealthModel(s => s.Section7.MentalHealth.HasDepression = value, true),
                            "margin-sm-right margin-md-left"
                        )}
                        {this.controlRenderer.renderCheckbox(
                            "PreviousPurifiedProteinDerivativeAbbrevLabel",
                            section7.MentalHealth.HasPreviousPurifiedProteinDerivative,
                            value => this.mutateMentalHealthModel(s => s.Section7.MentalHealth.HasPreviousPurifiedProteinDerivative = value, true),
                            "margin-lg-left"
                        )}
                    </div>
                    {this.controlRenderer.renderCheckbox(
                        "BipolarLabel",
                        section7.MentalHealth.HasBipolar,
                        value => this.mutateMentalHealthModel(s => s.Section7.MentalHealth.HasBipolar = value, true),
                        "margin-md-left"
                    )}
                    {this.controlRenderer.renderCheckbox(
                        "ObstetricalFile_EatingDisorderLabel",
                        section7.MentalHealth.HasEatingDisorder,
                        value => this.mutateMentalHealthModel(s => s.Section7.MentalHealth.HasEatingDisorder = value, true),
                        "margin-md-left"
                    )}
                    {this.controlRenderer.renderCheckbox(
                        "ObstetricalFile_SubstanceUseDisorder",
                        section7.MentalHealth.HasSubstanceUseDisorder,
                        value => this.mutateMentalHealthModel(s => s.Section7.MentalHealth.HasSubstanceUseDisorder = value, true),
                        "margin-md-left"
                    )}
                    <div className="padding-md-left">
                        {this.controlRenderer.renderCheckbox(
                            "MethadoneTreatmentLabel",
                            section7.MentalHealth.HasMethadoneTreatment,
                            value => this.mutateMentalHealthModel(s => {
                                s.Section7.MentalHealth.HasMethadoneTreatment = value;
                                s.Section7.MentalHealth.HasSubstanceUseDisorder = s.Section7.MentalHealth.setSubstanceUseDisorder();
                            }, true),
                            "margin-md-left"
                        )}
                        {this.controlRenderer.renderCheckbox(
                            "SuboxoneTreatmentLabel",
                            section7.MentalHealth.HasSuboxoneTreatment,
                            value => this.mutateMentalHealthModel(s => {
                                s.Section7.MentalHealth.HasSuboxoneTreatment = value;
                                s.Section7.MentalHealth.HasSubstanceUseDisorder = s.Section7.MentalHealth.setSubstanceUseDisorder();
                            }, true),
                            "margin-md-left"
                        )}
                    </div>
                    {this.renderRadioCheckboxWithLabel(
                        `${this.sectionId}_MentalHealth_Other`,
                        "ObstetricalFile_OtherLabel",
                        section7.MentalHealth.Other.Value,
                        value => {
                            this.mutateMentalHealthModel(
                                s => s.Section7.MentalHealth.Other.Value = value,
                                true,
                                () => this.setFocusTextbox(value, this.medicalHistoryMentalHealthOther)
                            );
                        },
                        this.getAdditionalTextBox({
                            id: this.medicalHistoryMentalHealthOther,
                            value: section7.MentalHealth.Other.Description,
                            onChange: value => this.mutateMentalHealthModel(s => s.Section7.MentalHealth.Other.setDescriptionAndCheckbox(value)),
                            maxLength: this.page1FieldLimits.MedicalHistory_MentalHealth_OtherDescription.MaxChars,
                            valueClassName: "margin-xs-left"
                        }),
                        true,
                        "margin-md-left"
                    )}
                </div>
            </div>
        );
    }

    private mutateMentalHealthModel(mutation: (state: BritishColumbiaObstetricalFileForm) => void, updateForm?: boolean, then?: () => void): void {
        this.props.mutateModelState(
            s => {
                mutation(s);
                if (s.Section7.MentalHealth.HasMentalHealth == null)
                    s.Section7.MentalHealth.HasMentalHealth = s.Section7.MentalHealth.hasSelectedAnyMedicalHistoryMentalHealth();
            },
            () => {
                if (updateForm)
                    this.props.handleFormUpdate();

                then?.();
            }
        );
    }
}

export { BritishColumbiaObstetricalFileMedicalHistoryMentalHealth };
